<nb-card>
	<nb-card-body class="overflow-visible">
		<ng-container [ngSwitch]="getProcessType()">
			<initial-certification-dates *ngIf="isFirstYearInitial(product)" [order]="order" [product]="product" [clientLogged]="clientLogged"></initial-certification-dates>
			<transfer-dates *ngIf="isTransfer(product)" [order]="order" [product]="product"></transfer-dates>
			<single-next-audit-date *ngIf="isRecertification(product) || (!isFirstYearInitial(product) && !isTransfer(product))" [order]="order" [product]="product"></single-next-audit-date>
		</ng-container>
	</nb-card-body>
</nb-card>
